const RELOAD_AT_KEY = 'daiv_chunk_reload_at';
const MIN_GAP_MS = 60 * 1000;

export function isChunkLoadFailure(reasonOrMessage) {
  const message = String(reasonOrMessage?.message || reasonOrMessage || '');
  const name = String(reasonOrMessage?.name || '');
  return name === 'ChunkLoadError' || /Loading (CSS )?chunk .* failed|ChunkLoadError/i.test(message);
}

/**
 * After a deploy the old HTML references chunks that no longer exist. Reload once (not in a loop)
 * so the devotee lands on the new build instead of a broken drawer or missing animation.
 */
export function reloadOnceForChunkFailure() {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    if (Date.now() - last < MIN_GAP_MS) return false;
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  } catch {
    return false; // storage blocked: don't risk a reload loop
  }
  window.location.reload();
  return true;
}

export function installChunkRecovery() {
  window.addEventListener('unhandledrejection', (e) => {
    if (isChunkLoadFailure(e.reason)) reloadOnceForChunkFailure();
  });
  window.addEventListener('error', (e) => {
    if (isChunkLoadFailure(e.error || e.message)) reloadOnceForChunkFailure();
  });
}
